// Import model
import { GridFormLayout } from '../models/GridFormLayout';

// Import base class serializer
import { FormLayoutSerializer } from './FormLayoutSerializer';

// Import dependency types (models and enums used in properties)
import { GridFormRowLayout } from '../models/GridFormRowLayout';

// Import dependency serializers (for complex types)
import { GridFormRowLayoutSerializer } from './GridFormRowLayoutSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for GridFormLayout - handles JSON serialization and deserialization with type validation
 */
export class GridFormLayoutSerializer {
  /**
   * Deserializes a JSON string into a GridFormLayout instance
   */
  static deserialize(json: string): GridFormLayout {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a GridFormLayout instance
   */
  static fromObject(obj: any): GridFormLayout {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to GridFormLayout');
    }


    const instance: GridFormLayout = {
      breakpoint: obj['Breakpoint'] as string,
      t: obj['_t'] as string,
      rows: obj['Rows'] ? (obj['Rows'] as any[]).map((item: any) =>
        GridFormRowLayoutSerializer.fromObject(item)
      ) : [],
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of GridFormLayout instances
   */
  static deserializeArray(json: string): GridFormLayout[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a GridFormLayout instance to a JSON string
   */
  static serialize(instance: GridFormLayout): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a GridFormLayout instance to a plain object
   */
  static toObject(instance: GridFormLayout): any {
    return {
      'Breakpoint': instance.breakpoint,
      '_t': instance.t,
      'Rows': instance.rows?.map((item: any) =>
        GridFormRowLayoutSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of GridFormLayout instances to a JSON string
   */
  static serializeArray(instances: GridFormLayout[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
